import React, { useState, useMemo, useCallback, useEffect } from 'react'
import className from 'classnames'
import PropTypes from 'prop-types'

import SortableListLabel from './SortableListLabel'
import SortableListMenu from './SortableListMenu'
import './SortableList.scss'

const optionTitlesMap = {
  recentlyLogged: 'Recently Loggeed',
  recentlyViewed: 'Recently Viewed',
  recentlyAdded: 'Recently Added',
  relevance: 'Most Relevant',
  rank: 'Most Popular',
  date: 'Newest',
  liked: 'Most Liked',
  az: 'az',
  oldest: 'Oldest',
  title: 'Class Name  A-Z',
  completedTitle: 'Title A-Z',
  series: 'Program Name A-Z',
  plan: 'Program Name A-Z',
  style: 'Style A-Z',
  instructor: 'Instructor Name  A-Z',
  durationShortToLong: 'Duration Short-Long',
  durationLongToShort: 'Duration Long-Short',
  7: 'Last 7 Days',
  30: 'Last 30 Days',
  90: 'Last 90 Days',
  all: 'All Time'
}

const SortableList = ({
  order,
  onSort,
  sortableFields,
  alignLeftXs,
  sortLocation,
  isMobile
}) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const uuid = useMemo(() => crypto.randomUUID().slice(0, 4), [])

  const setOrder = useCallback(
    (newOrder) => {
      setMenuOpen(false)
      onSort?.(newOrder)
    },
    [onSort]
  )

  const toggleMenu = useCallback(() => {
    setMenuOpen((prev) => !prev)
  }, [])

  const listClass = className(`SortableList SortableList_${uuid}`, {
    'SortableList--open': menuOpen,
    'SortableList--left': alignLeftXs
  })

  useEffect(() => {
    const handleClick = (event) => {
      if (event?.target?.closest(`.SortableList_${uuid}`)) {
        return
      }
      setMenuOpen(false)
    }

    document.addEventListener('click', handleClick)

    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [uuid])

  return (
    <div className={listClass} onClick={(e) => e.stopPropagation()}>
      <SortableListLabel
        onClick={toggleMenu}
        menuOpen={menuOpen}
        currentOrder={order}
        optionTitles={optionTitlesMap}
        isMobile={isMobile}
      />
      <SortableListMenu
        currOrder={order}
        sortableFields={sortableFields}
        setOrder={setOrder}
        optionTitles={optionTitlesMap}
        sortLocation={sortLocation}
      />
    </div>
  )
}

SortableList.propTypes = {
  order: PropTypes.string,
  onSort: PropTypes.func,
  sortableFields: PropTypes.array,
  alignLeftXs: PropTypes.bool,
  sortLocation: PropTypes.string,
  isMobile: PropTypes.bool
}

export default SortableList
